import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles/tokens.css";

const el = document.getElementById("root");
if (!el) throw new Error("#root nicht gefunden");

createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
